import { Tendv2ContentItem } from '../../api/tendApi';

export const PLACEHOLDER_TEXTS = {
  post: {
    source_title: 'Breaking: Major Policy Reform Announced',
    source_subhead: 'Officials reveal comprehensive plan affecting millions nationwide',
    generated_body: 'The sweeping changes were announced during a press conference at the capitol building, marking one of the most significant policy shifts in recent years.',
    source_category: 'Politics',
  },
  carousel_intro: {
    source_title: 'The Complete Guide to Policy Reform',
    source_subhead: 'Everything you need to know about the latest changes',
    generated_body: 'Our comprehensive breakdown of the most important policy changes and what they mean for you.',
    source_category: 'Analysis',
  },
  carousel_body: {
    source_title: 'Key Changes You Need to Know',
    source_subhead: 'Five critical takeaways from the announcement',
    generated_body: 'From healthcare to education, these reforms touch every aspect of daily life. Here are the details.',
    source_category: 'Analysis',
  },
  carousel_outro: {
    source_title: 'What Comes Next?',
    source_subhead: 'Timeline and implementation details',
    generated_body: 'Follow our coverage as these reforms move through the legislative process and into implementation.',
    source_category: 'Analysis',
  },
  video: {
    source_title: 'Watch: Exclusive Interview on Reform',
    source_subhead: 'Leading experts weigh in on the impact',
    generated_body: 'Our panel of experts breaks down what these changes mean for communities across the country.',
    source_category: 'Video',
  },
};

export function createPlaceholderContentItem(
  slotKey: string,
  imageUrl?: string | null
): Tendv2ContentItem {
  const texts = PLACEHOLDER_TEXTS[slotKey as keyof typeof PLACEHOLDER_TEXTS] || PLACEHOLDER_TEXTS.post;

  return {
    id: -1,
    transformation_id: null,
    platform: 'instagram',
    tactic_id: 'placeholder',
    format: 'post',
    primary_text: texts.source_title,
    character_count: 0,
    word_count: 0,
    created_at: new Date().toISOString(),
    source_title: texts.source_title,
    source_subhead: texts.source_subhead,
    generated_body: texts.generated_body,
    source_category: texts.source_category,
    primary_image_url: imageUrl || null,
  } as Tendv2ContentItem;
}
